import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalRemoveEmployeeDocument = gql`
  mutation SalesPortalRemoveEmployee(
    $businessUUID: uuid!
    $employeeUUID: uuid!
    $supplierUUID: uuid!
  ) {
    removeEmployeeFromBusiness(
      business_id: $businessUUID
      employee_id: $employeeUUID
      supplier_id: $supplierUUID
    ) {
      employee_id
    }
  }
`;
export type SalesPortalRemoveEmployeeMutationFn = Apollo.MutationFunction<
  Types.SalesPortalRemoveEmployeeMutation,
  Types.SalesPortalRemoveEmployeeMutationVariables
>;
export function useSalesPortalRemoveEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalRemoveEmployeeMutation,
    Types.SalesPortalRemoveEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalRemoveEmployeeMutation,
    Types.SalesPortalRemoveEmployeeMutationVariables
  >(SalesPortalRemoveEmployeeDocument, options);
}
export type SalesPortalRemoveEmployeeMutationHookResult = ReturnType<
  typeof useSalesPortalRemoveEmployeeMutation
>;
export type SalesPortalRemoveEmployeeMutationResult =
  Apollo.MutationResult<Types.SalesPortalRemoveEmployeeMutation>;
export type SalesPortalRemoveEmployeeMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalRemoveEmployeeMutation,
    Types.SalesPortalRemoveEmployeeMutationVariables
  >;
